import { useNavigate } from 'react-router-dom';
import NoSubjectsAllocatedImage from '../../assets/images/NoSubjectsAllocatedScreen.svg';
import ReloadIcon from '../../assets/images/ReloadIcon.svg';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import { PlatformType } from '../../types/platforms';
const JasperNoBooks = () => {
    const navigate = useNavigate();
    const handleRefresh = () => {
        navigate(0);
    };
    const product = useSelector(
        (state: RootState) => state.product
    ) as PlatformType;
    return (
        <div className=" flex items-center justify-center mt-[5rem]">
            <div className=" flex items-center justify-center flex-col">
                <img
                    src={NoSubjectsAllocatedImage}
                    alt="No books are jasper enabled"
                />
                <p className=" text-3xl font-bold text-black mt-2">
                    {product !== 'Buildr'
                        ? 'No books are jasper enabled'
                        : 'No books are assessment enabled'}
                </p>
                {product != 'Buildr' && (
                    <p className="text-black font-light text-xl mt-2">
                        Please ask Your Academic Coordinator to allocate the
                        jasper enabled books and click on refresh.
                    </p>
                )}
                <div
                    className="mt-4 px-6 py-2 flex justify-center space-x-2  bg-blue-500 text-white rounded-xl hover:bg-blue-600 hover:cursor-pointer"
                    onClick={handleRefresh}
                >
                    <img src={ReloadIcon} alt="Refresh Icon" />
                    <p>Refresh</p>
                </div>
            </div>
        </div>
    );
};

export default JasperNoBooks;
